import './Home.scss'
import content from './content.json'
import { Markup } from 'react-render-markup';
import {HeroSection} from './sections/hero/HeroSection'
import {useMediaQueries} from '../../hooks/mediaQuery/useMediaQueries'
import {AboutSection} from './sections/about/AboutSection'
import {CTABanner} from './sections/cta-banner/CTABanner'
import {Pricing} from './sections/pricing/Pricing'
import {FAQ} from './sections/faq/FAQ'
import {Helmet} from 'react-helmet-async'
import {useHomeScrollAnimation} from './hooks/useHomeScrollAnimation'

export const Home = () => {
    const { minTablet } = useMediaQueries()
    useHomeScrollAnimation()

    return (
        <>
            <Helmet>
                <title>{content?.pageTitle}</title>
            </Helmet>
            <HeroSection>
                <HeroSection.Caption><Markup markup={content?.hero?.caption}/></HeroSection.Caption>
                <HeroSection.Heading><Markup markup={content?.hero?.heading}/></HeroSection.Heading>
                <HeroSection.Description>
                    <Markup markup={minTablet ? content?.hero?.description?.desktop : content?.hero?.description?.mobile} />
                </HeroSection.Description>
                <HeroSection.PrimaryCTA>{content?.hero?.labels?.primaryCta}</HeroSection.PrimaryCTA>
                <HeroSection.SecondaryCTA>{content?.hero?.labels?.secondaryCta}</HeroSection.SecondaryCTA>
            </HeroSection>
            <AboutSection />
            <Pricing />
            <FAQ />
            <CTABanner>
                <CTABanner.Header>{content?.banner?.title1}<br/>{content?.banner?.title2}</CTABanner.Header>
                <CTABanner.PrimaryCTA>{content?.hero?.labels?.primaryCta}</CTABanner.PrimaryCTA>
            </CTABanner>
        </>
    )
}